var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 2H9.00009C4.00011 2 2.00012 3.99999 2.00012 8.99997V14.9999C2.00012 19.9999 4.00011 21.9999 9.00009 21.9999H15.0001C20 21.9999 22 19.9999 22 14.9999V13",
    stroke: "#22AD80",
    strokeWidth: 1.79999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0398 3.02025L8.15987 10.9002C7.85988 11.2002 7.55988 11.7902 7.49988 12.2202L7.06988 15.2302C6.90988 16.3202 7.67988 17.0802 8.76987 16.9302L11.7799 16.5002C12.1999 16.4402 12.7899 16.1402 13.0999 15.8402L20.9798 7.96023C22.3398 6.60023 22.9798 5.02024 20.9798 3.02025C18.9798 1.02026 17.3998 1.66025 16.0398 3.02025Z",
    stroke: "#22AD80",
    strokeWidth: 1.79999,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9099 4.15039C15.5799 6.54038 17.4499 8.41037 19.8499 9.09037",
    stroke: "#22AD80",
    strokeWidth: 1.79999,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.530b87242e4909f445d85aa8744d05e4.svg";
export { ForwardRef as ReactComponent };